import React from 'react';
import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var StorefrontManagement = createSvgIcon( /*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    "clip-rule": "evenodd",
    d: "M11.5 4C9.84315 4 8.5 5.34315 8.5 7C8.5 8.65685 9.84315 10 11.5 10C13.1569 10 14.5 8.65685 14.5 7C14.5 5.34315 13.1569 4 11.5 4ZM6.5 7C6.5 4.23858 8.73858 2 11.5 2C14.2614 2 16.5 4.23858 16.5 7C16.5 9.76142 14.2614 12 11.5 12C8.73858 12 6.5 9.76142 6.5 7Z",
    fill: "black",
    "fill-rule": "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    d: "M11.5 16C10.5544 16 8.39534 16.0006 7.87945 16.0358C7.37254 16.0704 7.07734 16.135 6.85195 16.2284C6.11687 16.5329 5.53284 17.1169 5.22836 17.852C5.135 18.0774 5.07033 18.3726 5.03574 18.8795C5.00054 19.3954 5 20.0545 5 21C5 21.5523 4.55229 22 4 22C3.44772 22 3 21.5523 3 21V20.9645C2.99999 20.0628 2.99999 19.3354 3.04038 18.7433C3.08191 18.1346 3.16948 17.5963 3.3806 17.0866C3.88807 15.8615 4.86144 14.8881 6.08658 14.3806C6.59628 14.1695 7.13456 14.0819 7.74331 14.0404C8.33531 14 10.5982 14 11.5 14V16Z",
    fill: "black"
  }), /*#__PURE__*/_jsx("path", {
    "clip-rule": "evenodd",
    d: "M17 21V20H14C13.4477 20 13 19.5523 13 19V14.5C13 13.6716 13.6716 13 14.5 13H21.5C22.3284 13 23 13.6716 23 14.5V19C23 19.5523 22.5523 20 22 20H19V21H20C20.5523 21 21 21.4477 21 22C21 22.5523 20.5523 23 20 23H16C15.4477 23 15 22.5523 15 22C15 21.4477 15.4477 21 16 21H17ZM15 15V18H21V15H15Z",
    fill: "black",
    "fill-rule": "evenodd"
  })]
}), 'StorefrontManagement');
export var StorefrontManagementHover = createSvgIcon( /*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    "clip-rule": "evenodd",
    d: "M11.5 4C9.84315 4 8.5 5.34315 8.5 7C8.5 8.65685 9.84315 10 11.5 10C13.1569 10 14.5 8.65685 14.5 7C14.5 5.34315 13.1569 4 11.5 4ZM6.5 7C6.5 4.23858 8.73858 2 11.5 2C14.2614 2 16.5 4.23858 16.5 7C16.5 9.76142 14.2614 12 11.5 12C8.73858 12 6.5 9.76142 6.5 7Z",
    fill: "#0077D4",
    "fill-rule": "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    d: "M11.5 16C10.5544 16 8.39534 16.0006 7.87945 16.0358C7.37254 16.0704 7.07734 16.135 6.85195 16.2284C6.11687 16.5329 5.53284 17.1169 5.22836 17.852C5.135 18.0774 5.07033 18.3726 5.03574 18.8795C5.00054 19.3954 5 20.0545 5 21C5 21.5523 4.55229 22 4 22C3.44772 22 3 21.5523 3 21V20.9645C2.99999 20.0628 2.99999 19.3354 3.04038 18.7433C3.08191 18.1346 3.16948 17.5963 3.3806 17.0866C3.88807 15.8615 4.86144 14.8881 6.08658 14.3806C6.59628 14.1695 7.13456 14.0819 7.74331 14.0404C8.33531 14 10.5982 14 11.5 14V16Z",
    fill: "#0077D4"
  }), /*#__PURE__*/_jsx("path", {
    "clip-rule": "evenodd",
    d: "M17 21V20H14C13.4477 20 13 19.5523 13 19V14.5C13 13.6716 13.6716 13 14.5 13H21.5C22.3284 13 23 13.6716 23 14.5V19C23 19.5523 22.5523 20 22 20H19V21H20C20.5523 21 21 21.4477 21 22C21 22.5523 20.5523 23 20 23H16C15.4477 23 15 22.5523 15 22C15 21.4477 15.4477 21 16 21H17ZM15 15V18H21V15H15Z",
    fill: "#0077D4",
    "fill-rule": "evenodd"
  })]
}), 'StorefrontManagementHover');
export var StorefrontManagementFilled = createSvgIcon( /*#__PURE__*/_jsxs("svg", {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/_jsx("path", {
    "clip-rule": "evenodd",
    d: "M11.5 4C9.84315 4 8.5 5.34315 8.5 7C8.5 8.65685 9.84315 10 11.5 10C13.1569 10 14.5 8.65685 14.5 7C14.5 5.34315 13.1569 4 11.5 4ZM6.5 7C6.5 4.23858 8.73858 2 11.5 2C14.2614 2 16.5 4.23858 16.5 7C16.5 9.76142 14.2614 12 11.5 12C8.73858 12 6.5 9.76142 6.5 7Z",
    fill: "#0077D4",
    "fill-rule": "evenodd"
  }), /*#__PURE__*/_jsx("path", {
    d: "M11.5 16C10.5544 16 8.39534 16.0006 7.87945 16.0358C7.37254 16.0704 7.07734 16.135 6.85195 16.2284C6.11687 16.5329 5.53284 17.1169 5.22836 17.852C5.135 18.0774 5.07033 18.3726 5.03574 18.8795C5.00054 19.3954 5 20.0545 5 21C5 21.5523 4.55229 22 4 22C3.44772 22 3 21.5523 3 21V20.9645C2.99999 20.0628 2.99999 19.3354 3.04038 18.7433C3.08191 18.1346 3.16948 17.5963 3.3806 17.0866C3.88807 15.8615 4.86144 14.8881 6.08658 14.3806C6.59628 14.1695 7.13456 14.0819 7.74331 14.0404C8.33531 14 10.5982 14 11.5 14V16Z",
    fill: "#0077D4"
  }), /*#__PURE__*/_jsx("path", {
    "clip-rule": "evenodd",
    d: "M17 21V20H14C13.4477 20 13 19.5523 13 19V14.5C13 13.6716 13.6716 13 14.5 13H21.5C22.3284 13 23 13.6716 23 14.5V19C23 19.5523 22.5523 20 22 20H19V21H20C20.5523 21 21 21.4477 21 22C21 22.5523 20.5523 23 20 23H16C15.4477 23 15 22.5523 15 22C15 21.4477 15.4477 21 16 21H17ZM15 15V18H21V15H15Z",
    fill: "#0077D4",
    "fill-rule": "evenodd"
  })]
}), 'StorefrontManagementFilled');